import Mapper from '@/models/mappers/Mapper';
import { FontGroup } from '@/models/entities/FontGroup';
import { FontGroupDTO } from '@/api/dto/FontGroupDTO';
import { mapValueToInterface } from '@/utils/models';

export class FontGroupMapper extends Mapper<FontGroup, FontGroupDTO> {
  mapFromDTO(fontGroupDTO: FontGroupDTO): FontGroup {
    return new FontGroup(<Partial<FontGroup>>fontGroupDTO);
  }

  mapToDTO(fontGroup: FontGroup): FontGroupDTO {
    return mapValueToInterface(fontGroup) as FontGroupDTO;
  }
}
